module.exports = __webpack_public_path__ + "static/media/box-xs.97ff3fba.png";